import { Trans } from 'react-i18next';
import { useMemo } from 'react';

import { RefundType } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { RadioGroupItem, StyledFlex } from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../../../translations';
import { AdvancePaymentsSettingsFormController } from '../AdvancePaymentsSettingsForm.types';

import { FullRefundThresholdInHoursField } from './FullRefundThresholdInHoursField';

const t = serviceSettingsTranslationKeys.advancePayments.form.refundTypeField;

type UseRefundTypeRadioItemsOptions = Pick<AdvancePaymentsSettingsFormController, 'register' | 'watch'>;

export const useRefundTypeRadioItems = (options: UseRefundTypeRadioItemsOptions): RadioGroupItem<RefundType>[] => {
   return useMemo(
      () => [
         {
            id: 'FULL_REFUND',
            verticalPosition: 'CENTER',
            label: (
               <StyledFlex alignItems={'center'} gap={8}>
                  <Trans
                     i18nKey={t.fullRefund.label}
                     components={{
                        FullRefundThresholdInputField: (
                           <FullRefundThresholdInHoursField register={options.register} watch={options.watch} />
                        ),
                     }}
                  />
               </StyledFlex>
            ),
         },
         {
            id: 'TIME_BASED_REFUND',
            label: t.timeBasedRefund.label,
         },
      ],
      [options]
   );
};
